import {
  TiptapBase,
  Heading,
  Blockquote,
  BulletList,
  OrderedList,
  Bold,
  Color,
  Italic,
  Strike,
  History,
  FontFamily,
  Link,
  Underline,
  TextAlign,
  HardBreak,
  HorizontalRule,
  ListItem,
  TextStyle,
  TaskLists,
  AutoSaveNotes,
  Placeholder,
} from '@/js/util/tiptap/extensions';

import {
  BlockquoteHandlers,
  FontFamilyHandlers,
  HeadingLevelHandlers,
  HistoryHandlers,
  HorizontalRuleHandlers,
  LinksHandlers,
  ListsHandlers,
  TaskListHandlers,
  TextAlignmentHandlers,
  TextColorHandlers,
  TextFormattingHandlers,
  PrintHandlers,
} from '@/js/util/tiptap/handlers';

const placeholder = 'Please add project notes';

export default class DesignerNotesConfig {
  get extensions() {
    const DesignerNotesPlaceholder = Placeholder[0].configure({ placeholder });

    return [
      ...TiptapBase,
      ...Heading,
      ...Blockquote,
      ...BulletList,
      ...OrderedList,
      ...Bold,
      ...Color,
      ...Italic,
      ...Strike,
      ...History,
      ...FontFamily,
      ...Link,
      ...Underline,
      ...TextAlign,
      ...HardBreak,
      ...HorizontalRule,
      ...ListItem,
      ...TextStyle,
      ...TaskLists,
      ...AutoSaveNotes,
      ...[DesignerNotesPlaceholder],
    ];
  }

  get handlers() {
    return {
      ...BlockquoteHandlers,
      ...FontFamilyHandlers,
      ...HeadingLevelHandlers,
      ...HistoryHandlers,
      ...HorizontalRuleHandlers,
      ...LinksHandlers,
      ...ListsHandlers,
      ...TextAlignmentHandlers,
      ...TextColorHandlers,
      ...TextFormattingHandlers,
      ...TaskListHandlers,
      ...PrintHandlers,
    };
  }
}
